'use strict';

import Cookies from "universal-cookie";
import {cartTopShow} from "./cart-top";
import {creditShow} from "./credit";
import {assemblyShow} from "./assembly-new";

export {cart};

let showCartPopup = false;
let addToCartCallback = null;

let cart = {
    getSummary: function(callback, carry_id, payment_id, phone){
        if(typeof carry_id == 'undefined'){
            carry_id = 0;
        }
        if(typeof payment_id == 'undefined'){
            payment_id = 0;
        }
        if(typeof phone == 'undefined'){
            phone = '';
        }

        const recipeUrl = baseUrl + 'cart/summary/?carry_id='+carry_id + '&payment_id=' + payment_id + '&phone=' + phone;

        const requestMetadata = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        };

        fetch(recipeUrl, requestMetadata)
            .then(res => res.json())
            .then(res => {
                if(typeof res.data.items != 'undefined'){

                }
                if(typeof callback != 'undefined')
                    callback(res);
            });
    },

    updateProduct: function(product_id, quantity, parent_id, assembly_id, bundle_id, services, callback){
        const recipeUrl = baseUrl + 'cart/update-product/';
        const postBody = {
            product_id: product_id,
            quantity: quantity,
            parent_id: parent_id,
            assembly_id: assembly_id,
            bundle_id: bundle_id,
            services: services,
            nodata: callback === null
        };

        const requestMetadata = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(postBody)
        };

        fetch(recipeUrl, requestMetadata)
            .then(res => res.json())
            .then(res => {
                let $wrapper = $('.product_wrapper[data-id_product=' + product_id + ']');
                if($wrapper.length && !$wrapper.hasClass('productpage')){
                    esputnikSendEvent('ProductPage', {
                        ProductPage: {
                            productKey: 'product_id',
                            price: $wrapper.attr('data-price').toString(),
                            isInStock: 1
                        },
                        GeneralInfo: {
                            s_location: $wrapper.find('a').attr('href')
                        }
                    });
                }
                if(callback !== null){
                    let ess = res.data.items.map(item => {
                        return dataLay.getObjectsReact(item, false, item.quantity).map(elem => {
                            return {
                                productKey: elem.item_id.toString(),
                                price: elem.price.toString(),
                                quantity: elem.quantity.toString(),
                                currency: elem.currency
                            };
                        });
                    }).flat(1);

                    esputnikSendEvent('StatusCart', {
                        StatusCart: ess,
                        GUID: res.data.hash
                    });
                    /*
                    if(quantity == 1){
                        cartTopShow(res.data, false);
                    }
                     */

                    if(typeof callback != 'undefined')
                        callback(res);
                }

            });
    },

    updateAssembly: function(assembly_id, quantity, assembly_service, services, callback, route = 'cart/update-assembly/'){
        const recipeUrl = baseUrl + route;
        const postBody = {
            assembly_id: assembly_id,
            quantity: quantity,
            services: services,
            assembly_service: assembly_service,
        };

        const requestMetadata = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(postBody)
        };
        fetch(recipeUrl, requestMetadata)
            .then(res => res.json())
            .then(res => {
                if(quantity == 1 && res.data){
                    cartTopShow(res.data, false);
                }
                callback(res);
            });
    },

    updateBundle: function(bundle_id, quantity, callback){
        const recipeUrl = baseUrl + 'cart/update-bundle/';
        const postBody = {
            bundle_id: bundle_id,
            quantity: quantity,
            nodata: callback === null
        };

        const requestMetadata = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(postBody)
        };
        fetch(recipeUrl, requestMetadata)
            .then(res => res.json())
            .then(res => {
                if(callback)
                    callback(res);
            });
    },

    getPromocodes: function(){
        let promocodes = [];
        try{
            promocodes = (new Cookies()).get('promocodes') || [];
        }catch(e){
        }

        return promocodes;
    },
    addPromocode: function(promocode){
        let promocodes = this.getPromocodes();
        promocodes.push(promocode);
        promocodes = promocodes.filter((v, i, a) => a.indexOf(v) === i);
        (new Cookies()).set('promocodes', JSON.stringify(promocodes), {path: '/'});
    },

    removePromocode: function(promocode){
        let promocodes = this.getPromocodes();
        promocodes = promocodes.filter(function(ele){
            return ele != promocode;
        });
        (new Cookies()).set('promocodes', JSON.stringify(promocodes), {path: '/'});
    },

};
$(function (){
    $('.main .content').on('click', '.add-to-cart-couple', function(){
        let $couple_wrapper = $(this).closest('.couple_wrapper');
        cart.updateBundle($(this).attr('data-id_bundle'), 0, function(res){
            $.each($couple_wrapper.find('.product_wrapper .add-to-cart'), function(index){
                if(index < $couple_wrapper.find('.product_wrapper .add-to-cart').length -1){
                    $(this).closest('.product_wrapper').addClass('couple_not_last');
                }
                setTimeout(function(elem, index){
                    $(elem).trigger('click');
                }, (index + 1) * 300, this);

            });
        });

    });

    $('.main .content').on('click', '.add-to-cart-accessories', function(){
        let $accessories_block = $('.accessories_block');
        let prods = $accessories_block.find('.product_wrapper .hardevel_accessory_add.preview-product__btn_cart--active + button')
        $.each(prods, function(index){
            if(index < prods.length -1){
                $(this).closest('.product_wrapper').addClass('couple_not_last');
            }
            setTimeout(function(elem, index){
                $(elem).trigger('click');
            }, (index + 1) * 300, this);
        });

        setTimeout(function(elem){
            $(elem).trigger('click');
        }, (prods.length + 1) * 300, $('.card-block__fixed-footer .add-to-cart'));
    });

    $('.main .content').on('click', '.credit_popup', function(){
        let $wrapper = $(this).closest('.product_wrapper');
        creditShow({
            sum: $wrapper.attr('data-price'),
            mb_max_payment_quantity: $wrapper.attr('data-mb_max_payment_quantity'),
            pl_max_payment_quantity: $wrapper.attr('data-pl_max_payment_quantity'),
            pb_max_payment_quantity: $wrapper.attr('data-pb_max_payment_quantity'),
            pu_max_payment_quantity: $wrapper.attr('data-pu_max_payment_quantity'),
            ab_max_payment_quantity: $wrapper.attr('data-ab_max_payment_quantity'),
        }, window.offers, function (){ $('.card-block__buy-row .add-to-cart').trigger('click'); setTimeout(function(){window.location.href = window.orderLink;}, 500) }, $(this).attr('data-type'));
    });

    $('.main .content').on('click', '.add-to-cart', function(){

        let $button = $(this);
        let $wrapper = $button.closest('.product_wrapper');
        let services = [];
        if (!$wrapper.hasClass('card-block__extra-item')){
            services = window.productPageServices;
        }

        /*
        $wrapper.find('.service-input:checked').each(function(elem){
            services.push($(this).attr('data-id_product'));
        });
        */
        if($wrapper.attr('data-id_assembly')){
            assemblyShow($wrapper.attr('data-id_assembly'), function(id_assembly, assembly_service, services){
                cart.updateAssembly(parseInt($wrapper.attr('data-id_assembly')), 1, assembly_service, services, (json) => {

                    if($button.hasClass('credit')){
                        creditShow(json.data, window.offers, $button.attr('data-type'));
                    }else{
                        cartTopShow(json.data, true);
                    }

                    var dataL = {
                        'event':'MTRENDO',
                        'eventCategory': 'EEC',
                        'eventAction':'add_to_cart',
                        'eventLabel': $wrapper.attr('data-prod-name'),
                        'products': [{
                            'name': $wrapper.attr('data-prod-name'),
                            'id': $wrapper.attr('data-prod-id'),
                            'articul': $wrapper.attr('data-prod-articul'),
                            'price': $wrapper.attr('data-prod-price'),
                            'category': $wrapper.attr('data-prod-category'),
                            'list': $wrapper.attr('data-prod-list'),
                            'variant':  $wrapper.attr('data-prod-variant'),
                            'brand': $wrapper.attr('data-prod-brand'),
                            'position': $wrapper.attr('data-prod-position'),
                            'quantity': 1
                        }]
                    };
                    window.dataLayer.push(dataL);

                    let object = dataLay.getObject($wrapper);
                    object['quantity'] = 1;
                    object['currency'] = 'UAH';
                    dataLay.sendData([object], 'add_to_cart');

                });
            }, [], $('#addSupport').is(':checked') || $('#addSupport2').is(':checked'));
            /*

             */
        }else if($wrapper.attr('data-id_product')){
            if($wrapper.attr('data-promocode')){
                cart.addPromocode($wrapper.attr('data-promocode'));
            }
            let callb = null;
            if(!$wrapper.hasClass('couple_not_last')){
                callb = function (json) {
                    if($button.hasClass('card-block__buy-on-credit') || $button.hasClass('credit')){
                        creditShow(json.data, window.offers, $button.attr('data-type'));
                    }else{
                        cartTopShow(json.data, true);
                    }
                    var dataL = {
                        'event':'MTRENDO',
                        'eventCategory': 'EEC',
                        'eventAction':'add_to_cart',
                        'eventLabel': $wrapper.attr('data-prod-name'),
                        'products': [{
                            'name': $wrapper.attr('data-prod-name'),
                            'id': $wrapper.attr('data-prod-id'),
                            'articul': $wrapper.attr('data-prod-articul'),
                            'price': $wrapper.attr('data-prod-price'),
                            'category': $wrapper.attr('data-prod-category'),
                            'list': $wrapper.attr('data-prod-list'),
                            'variant':  $wrapper.attr('data-prod-variant'),
                            'brand': $wrapper.attr('data-prod-brand'),
                            'position': $wrapper.attr('data-prod-position'),
                            'quantity': 1
                        }]
                    };

                    window.dataLayer.push(dataL);

                    let object = dataLay.getObject($wrapper);
                    object['quantity'] = 1;
                    object['currency'] = 'UAH';
                    dataLay.sendData([object], 'add_to_cart');

                };
            }
            if(callb)
                cart.updateProduct($wrapper.attr('data-id_product'), 1, null, null, $wrapper.attr('data-id_bundle'), services, (json) => callb(json));
            else
                cart.updateProduct($wrapper.attr('data-id_product'), 1, null, null, $wrapper.attr('data-id_bundle'), services, null);
        }
    });
});
/*
export function getSummary(callback)
{
    const recipeUrl = baseUrl + 'cart/summary/';
    const postBody = {
        product_id: product_id,
        quantity: quantity,
        parent_id: parent_id,
    };

    const requestMetadata = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(postBody)
    };

    fetch(recipeUrl, requestMetadata)
        .then(res => res.json())
        .then(res => {
            callback(res);
        });
}

 */